import { useAppSelector } from '@brands/hooks/useReduxHook';
import { UserRoleName } from '@brands/services/identity/types/UserProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import React from 'react';

import UserProfilePage from './CareAdvisor/UserProfile/UserProfilePage';
import CreateUserPage from './CareAdvisor/Users/CreateUserPage';
import UsersPage from './CareAdvisor/Users/UsersPage';
import AddNewUserPage from './Collector/AddNewUser/AddNewUserPage';
import CollectorUsersPage from './Collector/CollectorUsersPage';
import EditUserPage from './Collector/EditUser/EditUserPage';
import AddUserPage from './SuperAdmin/AddUser/AddUserPage';

/** Care Advisor uses CA users UI inside CareAdvisorLayout; Collector uses collector pages with Container (nav + sidebar). */
export const UsersRouteByRole: React.FC = () => {
  const { userInfo } = useAppSelector(selectAuth);
  if (userInfo?.role?.name === UserRoleName.Collector) return <CollectorUsersPage />;
  return <UsersPage />;
};

export const UsersNewRouteByRole: React.FC = () => {
  const { userInfo } = useAppSelector(selectAuth);
  if (userInfo?.role?.name === UserRoleName.Collector || userInfo?.role?.name === UserRoleName.CareAdvisor)
    return <AddNewUserPage />;
  if (
    userInfo?.role?.name === UserRoleName.Admin ||
    userInfo?.role?.name === UserRoleName.SuperAdmin ||
    userInfo?.role?.name === UserRoleName.OrganizationAdmin
  ) {
    return <AddUserPage />;
  }
  return <CreateUserPage />;
};

export const UserDetailRouteByRole: React.FC = () => {
  const { userInfo } = useAppSelector(selectAuth);
  if (userInfo?.role?.name === UserRoleName.Collector) return <EditUserPage />;
  return <UserProfilePage />;
};
